import script from "./EventItemList.vue?vue&type=script&setup=true&lang=js"
export * from "./EventItemList.vue?vue&type=script&setup=true&lang=js"

import "./EventItemList.vue?vue&type=style&index=0&id=63864a17&scoped=true&lang=css"

import exportComponent from "/home/jenkins/storybird-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63864a17"]])

export default __exports__